import { Loader2 } from "lucide-react";
import type { ClassData } from "@/lib/api";

interface ClassSectionProps {
  classes: ClassData[];
  loadingClasses: boolean;
  selectedClass: string;
  onClassChange: (classId: string) => void;
  selectedSubject: string;
}

export const ClassSection: React.FC<ClassSectionProps> = ({
  classes,
  loadingClasses,
  selectedClass,
  onClassChange,
  selectedSubject,
}) => {
  return (
    <>
      <div className="bg-(--card-bg) border border-(--border-color) rounded-2xl p-6 shadow-sm mb-2">
        <div className="space-y-6">
          <div>
            <label className="block text-xs font-bold uppercase tracking-wider mb-2 text-(--text-tertiary)">
              Selecione a Turma <span className="text-red-500">*</span>
            </label>
            {loadingClasses ? (
              <div className="w-full rounded-xl border p-4 flex items-center gap-3 bg-(--bg-secondary) border-transparent">
                <Loader2 className="w-5 h-5 animate-spin text-(--primary-color)" />
                <span className="text-(--text-tertiary) font-medium text-sm">
                  Carregando turmas...
                </span>
              </div>
            ) : (
              <select
                value={selectedClass}
                onChange={(e) => onClassChange(e.target.value)}
                className="w-full rounded-xl border border-(--border-color) p-4 focus:ring-2 focus:ring-blue-500/20 focus:border-(--primary-color) outline-none transition-all hover:border-(--text-tertiary) font-semibold text-(--text-primary) bg-(--card-bg) cursor-pointer"
              >
                <option value="">Clique para selecionar...</option>
                {classes.length > 0 ? (
                  classes.map((classItem) => (
                    <option key={classItem.id} value={classItem.id}>
                      {classItem.name}
                    </option>
                  ))
                ) : (
                  <option disabled>Nenhuma turma encontrada</option>
                )}
              </select>
            )}
          </div>

          <div>
            <label className="block text-xs font-bold uppercase tracking-wider mb-2 text-(--text-tertiary)">
              Disciplina / Matéria
            </label>
            {!selectedClass ? (
              <div className="w-full rounded-xl border p-4 text-sm flex items-center bg-(--bg-secondary) border-transparent">
                <span className="text-(--text-tertiary) italic">
                  Aguardando seleção de turma...
                </span>
              </div>
            ) : (
              <div className="w-full rounded-xl border p-4 flex items-center bg-blue-50/50 border-blue-100">
                <span className="font-bold text-(--primary-color)">
                  {selectedSubject || "Carregando disciplina..."}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
